/**
 * TanStack Query hooks for `mfilterit-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	mfilteritIntegrationQueryKeys,
	type CreateMfilteritIntegrationBody,
	type ListMfilteritIntegrationResponse,
	type MfilteritIntegrationRow,
} from "./api";

export function useMfilteritIntegrationList(): UseQueryResult<ListMfilteritIntegrationResponse, Error> {
	return useQuery({
		queryKey: mfilteritIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useMfilteritIntegrationCreate(): UseMutationResult<MfilteritIntegrationRow, Error, CreateMfilteritIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: mfilteritIntegrationQueryKeys.all });
		},
	});
}

export function useMfilteritIntegrationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: mfilteritIntegrationQueryKeys.all });
		},
	});
}
